'use client';

import { getNodesFromConnection } from '@graphql/connections/getNodesFromConnection';
import { SpeciesCatchWithImageNodeFields, ImageFields } from '../../../../generated/graphql';
import styles from './HeaderSection.module.css';
import { Container } from '../../../../components/Container/Container';
import { HeaderImage } from './components/HeaderImage';

interface IProps {
  catchCount: number;
  numberOfNewCatches: number;
  exampleImage: ImageFields;
  examplePostId: string;
  displayName: string;
  recentCatches: SpeciesCatchWithImageNodeFields[];
  speciesId: string;
}

export const NR_OF_RECENT_CATCHES_TO_SHOW = 6;

export const HeaderSection = ({
  exampleImage,
  examplePostId,
  catchCount,
  numberOfNewCatches,
  displayName,
  recentCatches,
  speciesId,
}: IProps) => {
  return (
    <Container className="relative size-full p-0 sm:pt-6">
      <div
        className={`grid grid-flow-col gap-0.5 overflow-hidden sm:mx-0 sm:gap-1 ${styles.catchImagesGrid} sm:rounded-2xl`}
      >
        <HeaderImage
          catchCount={catchCount}
          imageHeight={exampleImage.height}
          imageUrl={exampleImage.url}
          imageWidth={exampleImage.width}
          isNewCatch={false}
          numberOfNewCatches={numberOfNewCatches}
          postId={examplePostId}
          speciesId={speciesId}
          speciesName={displayName}
        />
        {recentCatches.slice(0, NR_OF_RECENT_CATCHES_TO_SHOW).map(({ post }) => {
          const image = getNodesFromConnection(post.images)[0];
          const imageUrl = image?.url ?? '';
          const imageWidth = image?.width ?? 0;
          const imageHeight = image?.height ?? 0;
          return (
            <HeaderImage
              key={post._id}
              catchCount={catchCount}
              imageHeight={imageHeight}
              imageUrl={imageUrl}
              imageWidth={imageWidth}
              isNewCatch={false}
              numberOfNewCatches={numberOfNewCatches}
              postId={post._id}
              speciesId={speciesId}
              speciesName={displayName}
            />
          );
        })}
      </div>
    </Container>
  );
};
